import React, { useState, useEffect } from "react";
import { Input, Button, Checkbox, DatePicker, message, Modal } from "antd";
import styles from "../../ShishkaGuestLogin/ShishkaGuestLogin.module.css";
import Confetti from "react-confetti";
import FaceScanPage from "../Components/FaceScanPage";
import DataUserLoyalty from "../store/DataUserLoyalty";
import { observer } from "mobx-react-lite";
import { useNavigate, useLocation } from "react-router-dom";
import HelloModal from "../Components/HelloModal";
import { NavLink } from "react-router-dom";

const guestOnboardingAPI =
    "https://uvjwfdf5aa.execute-api.eu-west-1.amazonaws.com/test/guest-onboarding";

const Register = observer(() => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const placeId = params.get("place_id");
    // console.log(placeId);
    DataUserLoyalty.placeId = placeId;
    const [backgroundImage, setBackgroundImage] = useState(null);
    const [selectedHookahTypes, setSelectedHookahTypes] = useState([]);
    const [userName, setUserName] = useState("");
    const [userSurname, setUserSurname] = useState("");
    const [phone, setPhone] = useState("");
    const [dob, setDob] = useState(null);
    const [hookahPreferences, setHookahPreferences] = useState("");
    const [hookahDislikes, setHookahDislikes] = useState("");
    const [isChill, setIsChill] = useState(null);
    const [strengthRange, setStrengthRange] = useState([3, 4]);
    const [agreedToTerms, setAgreedToTerms] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showConfetti, setShowConfetti] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const isFormComplete =
        userName &&
        userSurname &&
        phone &&
        agreedToTerms &&
        DataUserLoyalty.images.length != 0;

    const handleRegister = async () => {
        console.log(placeId);

        if (!DataUserLoyalty.images) {
            message.error("Фото не загружено!");
            return;
        }
        setLoading(true);
        try {
            const requestBody = {
                place_id: DataUserLoyalty.placeId
                    ? DataUserLoyalty.placeId
                    : "blna25d8e8",
                // place_id: "blna25d8e8",
                properties: {
                    user_mobile: phone,
                    user_date_of_birth: dob,
                    user_hookah_preferences: hookahPreferences.split(","),
                    user_hookah_dislikes: hookahDislikes.split(","),
                    user_hookah_chill: isChill,
                    user_hookah_strength_range: strengthRange,
                    user_hookah_types: selectedHookahTypes,
                },
                user_name: userName,
                user_surname: userSurname,
                data_url: DataUserLoyalty.images,
            };

            const response = await fetch(guestOnboardingAPI, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestBody),
            });
            DataUserLoyalty.images = [];
            const data = await response.json();
            console.log(data.user_data);
            console.log(response);

            if (response.status === 200 && data.user_data != undefined) {
                setShowConfetti(true); // Show confetti
                console.log(response);

                localStorage.setItem("user", JSON.stringify(data.user_data));

                setShowSuccessModal(true); // Show success modal
                message.success("Регистрация успешна!");
                setTimeout(() => {
                    navigate(
                        `/userLoyalty/main${
                            DataUserLoyalty.placeId
                                ? `?place_id=${DataUserLoyalty.placeId}`
                                : ""
                        }`
                    );
                }, 2000);
            } else {
                message.error(data.message || "Ошибка регистрации");
                setSelectedHookahTypes([]);
                setUserName("");
                setUserSurname("");
                setPhone("");
            }
        } catch (error) {
            console.error("Ошибка:", error);
            message.error("Ошибка регистрации");
        } finally {
            setLoading(false);
        }
    };

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
        setShowConfetti(false); // Stop confetti
    };

    return (
        <div className={styles.wrapper}>
            <HelloModal />
            {backgroundImage && (
                <div
                    className={styles.background}
                    style={{ backgroundImage: `url(${backgroundImage})` }}
                />
            )}
            {/* Confetti Effect */}
            {showConfetti && (
                <Confetti
                    width={window.innerWidth}
                    height={window.innerHeight}
                    recycle={false}
                    numberOfPieces={500}
                    onConfettiComplete={() => setShowConfetti(false)}
                />
            )}
            {/* Success Modal */}
            <Modal
                visible={showSuccessModal}
                onCancel={handleCloseSuccessModal}
                footer={null}
                centered>
                <div style={{ textAlign: "center" }}>
                    <h2>Регистрация прошла успешно!</h2>
                    <p>Спасибо за регистрацию. Наслаждайтесь вашим временем!</p>
                    <Button type='primary' onClick={handleCloseSuccessModal}>
                        Закрыть
                    </Button>
                </div>
            </Modal>
            <div className={styles.formContainer}>
                <h1 className={styles.title}>Регистрация данных</h1>

                <FaceScanPage />
                <label className={styles.label}>Имя</label>
                <Input
                    className={styles.input}
                    value={userName}
                    onChange={(e) => {
                        setUserName(e.target.value);
                        DataUserLoyalty.userName = e.target.value;
                    }}
                />
                <label className={styles.label}>Фамилия</label>
                <Input
                    className={styles.input}
                    value={userSurname}
                    onChange={(e) => {
                        setUserSurname(e.target.value);
                        DataUserLoyalty.userName = e.target.value;
                    }}
                />
                <label className={styles.label}>Телефон</label>
                <Input
                    className={styles.input}
                    placeholder='+7'
                    value={phone}
                    onChange={(e) => {
                        setPhone(e.target.value);
                        DataUserLoyalty.userPhone = e.target.value;
                    }}
                />

                <Checkbox
                    className={styles.checkbox}
                    checked={agreedToTerms}
                    onChange={(e) => setAgreedToTerms(e.target.checked)}>
                    Я согласен на обработку <a href='#'>данных</a>
                </Checkbox>

                <NavLink to='/happyCitizen/survey' className='w-full'>
                    <Button
                        type='primary'
                        className={`w-full ${styles.registerButton} ${
                            isFormComplete ? styles.active : ""
                        }`}
                        disabled={!isFormComplete}>
                        Пройти опрос
                    </Button>
                </NavLink>
            </div>
        </div>
    );
});

export default Register;
